// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgePayloadStagingApi = class EdgePayloadStagingApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param systemCode
     * @param systemId
     * @param purposeCode
     * @param purposeId
     * @param x_program_id The program id from the list of allowed program ids
     */
    async dataGetData(systemCode, systemId, purposeCode, purposeId, x_program_id) {
        const _url_ = '/edge/PayloadStaging/V1/Data/GetData/{systemCode}/{systemId}/{purposeCode}/{purposeId}'
            .replace('{' + 'systemCode' + '}', encodeURIComponent(String(systemCode)))
            .replace('{' + 'systemId' + '}', encodeURIComponent(String(systemId)))
            .replace('{' + 'purposeCode' + '}', encodeURIComponent(String(purposeCode)))
            .replace('{' + 'purposeId' + '}', encodeURIComponent(String(purposeId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'systemCode' is not null or undefined
        if (systemCode === null || systemCode === undefined) {
            throw new Error('Required parameter systemCode was null or undefined when calling dataGetData.');
        }
        // verify required parameter 'systemId' is not null or undefined
        if (systemId === null || systemId === undefined) {
            throw new Error('Required parameter systemId was null or undefined when calling dataGetData.');
        }
        // verify required parameter 'purposeCode' is not null or undefined
        if (purposeCode === null || purposeCode === undefined) {
            throw new Error('Required parameter purposeCode was null or undefined when calling dataGetData.');
        }
        // verify required parameter 'purposeId' is not null or undefined
        if (purposeId === null || purposeId === undefined) {
            throw new Error('Required parameter purposeId was null or undefined when calling dataGetData.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayloadStagingV1DataGetDataSystemCodeSystemIdPurposeCodePurposeIdGetDataResponse");
        }
        return response;
    }
    /**
     *
     * @param CreateDataGroupRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async dataGroupCreateDataGroup(CreateDataGroupRequest, x_program_id) {
        const _url_ = '/edge/PayloadStaging/V1/DataGroup/CreateDataGroup';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'CreateDataGroupRequest' is not null or undefined
        if (CreateDataGroupRequest === null || CreateDataGroupRequest === undefined) {
            throw new Error('Required parameter CreateDataGroupRequest was null or undefined when calling dataGroupCreateDataGroup.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(CreateDataGroupRequest, "CreateDataGroupRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayloadStagingV1DataGroupCreateDataGroupCreateDataGroupResponse");
        }
        return response;
    }
    /**
     *
     * @param systemCode
     * @param systemId
     * @param x_program_id The program id from the list of allowed program ids
     */
    async dataGroupGetDataGroup(systemCode, systemId, x_program_id) {
        const _url_ = '/edge/PayloadStaging/V1/DataGroup/GetDataGroup/{systemCode}/{systemId}'
            .replace('{' + 'systemCode' + '}', encodeURIComponent(String(systemCode)))
            .replace('{' + 'systemId' + '}', encodeURIComponent(String(systemId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'systemCode' is not null or undefined
        if (systemCode === null || systemCode === undefined) {
            throw new Error('Required parameter systemCode was null or undefined when calling dataGroupGetDataGroup.');
        }
        // verify required parameter 'systemId' is not null or undefined
        if (systemId === null || systemId === undefined) {
            throw new Error('Required parameter systemId was null or undefined when calling dataGroupGetDataGroup.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayloadStagingV1DataGroupGetDataGroupSystemCodeSystemIdGetDataGroupResponse");
        }
        return response;
    }
    /**
     *
     * @param CreateDataRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async dataSetData(CreateDataRequest, x_program_id) {
        const _url_ = '/edge/PayloadStaging/V1/Data/SetData';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'CreateDataRequest' is not null or undefined
        if (CreateDataRequest === null || CreateDataRequest === undefined) {
            throw new Error('Required parameter CreateDataRequest was null or undefined when calling dataSetData.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(CreateDataRequest, "CreateDataRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayloadStagingV1DataSetDataSetDataResponse");
        }
        return response;
    }
    /**
     *
     * @param systemCode
     * @param systemId
     * @param purposeCode
     * @param purposeId
     * @param x_program_id The program id from the list of allowed program ids
     */
    async metaDataGetMetaData(systemCode, systemId, purposeCode, purposeId, x_program_id) {
        const _url_ = '/edge/PayloadStaging/V1/MetaData/GetMetaData/{systemCode}/{systemId}/{purposeCode}/{purposeId}'
            .replace('{' + 'systemCode' + '}', encodeURIComponent(String(systemCode)))
            .replace('{' + 'systemId' + '}', encodeURIComponent(String(systemId)))
            .replace('{' + 'purposeCode' + '}', encodeURIComponent(String(purposeCode)))
            .replace('{' + 'purposeId' + '}', encodeURIComponent(String(purposeId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'systemCode' is not null or undefined
        if (systemCode === null || systemCode === undefined) {
            throw new Error('Required parameter systemCode was null or undefined when calling metaDataGetMetaData.');
        }
        // verify required parameter 'systemId' is not null or undefined
        if (systemId === null || systemId === undefined) {
            throw new Error('Required parameter systemId was null or undefined when calling metaDataGetMetaData.');
        }
        // verify required parameter 'purposeCode' is not null or undefined
        if (purposeCode === null || purposeCode === undefined) {
            throw new Error('Required parameter purposeCode was null or undefined when calling metaDataGetMetaData.');
        }
        // verify required parameter 'purposeId' is not null or undefined
        if (purposeId === null || purposeId === undefined) {
            throw new Error('Required parameter purposeId was null or undefined when calling metaDataGetMetaData.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayloadStagingV1MetaDataGetMetaDataSystemCodeSystemIdPurposeCodePurposeIdGetMetaDataResponse");
        }
        return response;
    }
    /**
     *
     * @param CreateDataRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async metaDataSetMetaData(CreateDataRequest, x_program_id) {
        const _url_ = '/edge/PayloadStaging/V1/MetaData/SetMetaData';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'CreateDataRequest' is not null or undefined
        if (CreateDataRequest === null || CreateDataRequest === undefined) {
            throw new Error('Required parameter CreateDataRequest was null or undefined when calling metaDataSetMetaData.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(CreateDataRequest, "CreateDataRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayloadStagingV1MetaDataSetMetaDataSetMetaDataResponse");
        }
        return response;
    }
    /**
     *
     * @param RetrievePayloadRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async payloadRetrievePayload(RetrievePayloadRequest, x_program_id) {
        const _url_ = '/edge/PayloadStaging/V1/Payload/RetrievePayload';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'RetrievePayloadRequest' is not null or undefined
        if (RetrievePayloadRequest === null || RetrievePayloadRequest === undefined) {
            throw new Error('Required parameter RetrievePayloadRequest was null or undefined when calling payloadRetrievePayload.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(RetrievePayloadRequest, "RetrievePayloadRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayloadStagingV1PayloadRetrievePayloadRetrievePayloadResponse");
        }
        return response;
    }
    /**
     *
     * @param StagePayloadRequest default request body
     * @param x_program_id The program id from the list of allowed program ids
     */
    async payloadStagePayload(StagePayloadRequest, x_program_id) {
        const _url_ = '/edge/PayloadStaging/V1/Payload/StagePayload';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'StagePayloadRequest' is not null or undefined
        if (StagePayloadRequest === null || StagePayloadRequest === undefined) {
            throw new Error('Required parameter StagePayloadRequest was null or undefined when calling payloadStagePayload.');
        }
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(StagePayloadRequest, "StagePayloadRequest"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayloadStagingV1PayloadStagePayloadStagePayloadResponse");
        }
        return response;
    }
};
EdgePayloadStagingApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgePayloadStagingApi);
export { EdgePayloadStagingApi };
//# sourceMappingURL=edgePayloadStagingApi.js.map